package io.eqoty.shared.datalayer.sources.filesystem

import okio.FileSystem
import okio.fakefilesystem.FakeFileSystem


actual val SYSTEM: FileSystem = FakeFileSystem()